/** @format */

export interface MembershipStatusResponse {
  identityId: string;
  status: 'ACTIVE' | 'INACTIVE' | 'CANCELLED';
  renewalFlag: boolean;
  membershipStartDate: string;
  currentTermStart: string;
  currentTermEnd: string;
  pendingCertificates: ScorecardPlusCertificate[];
}

export interface ScorecardPlusCertificate {
  issueDate: string;
  certValue: number;
}
